import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { faqs } from '@/mocks/drama';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-8">
        <SectionHeading
          eyebrow="FAQ"
          title="观众常见问题"
          desc="整理了大家在了解这个题材时最常提到的几个问题，帮你少绕弯路。"
          align="center"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-xl text-primary-500 transition-transform duration-300 ${
                      isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}